import {Collapse, List, ListItem, ListItemIcon} from '@material-ui/core';
import * as React from 'react';
import IntlMessage from '../../util/IntlMessage';
import SingleNavLink from './SingleNavLink';
import {MenuSingleRenderShape} from './menuTypes';
import {connect} from 'react-redux';
import {compose} from 'redux';
import classNames from "classnames";
import {changeUserTourStep} from '../../actions';
import {userTourStepOpenDocumentUploading} from '../../constants';

interface DocumentsMenuItemProps {
    title: string;
    icon?: any;
    translateTitle?: boolean
    documentTypes: Array<MenuSingleRenderShape>;
}

interface InternalProps extends DocumentsMenuItemProps {
    changeUserTourStep: Function;
}

const DocumentsMenuItem: React.FunctionComponent<InternalProps> =
    ({title, documentTypes, icon: MenuIcon, changeUserTourStep}: InternalProps) => {
        const [subMenuOpen, handleSubMenuOpen] = React.useState(true);

        return (
            <React.Fragment>
                <ListItem
                    button
                    component="li"
                    onClick={(): void => {
                        handleSubMenuOpen(!subMenuOpen);
                    }}
                    className={`list-item ${classNames({'item-active': subMenuOpen})}`}
                >
                    <ListItemIcon className="menu-icon">
                        {MenuIcon ? <MenuIcon/> : null}
                    </ListItemIcon>
                    <span className="menu text-capitalize">
                        <IntlMessage id={title}/>
                    </span>
                </ListItem>
                <Collapse in={subMenuOpen} timeout="auto" className="sub-menu">
                    <React.Fragment>
                        <List
                            className="list-unstyled py-0"
                            data-user-tour='step-choose-doc-type'
                        >
                            {documentTypes && documentTypes.map((docType) => {
                                return (
                                    <SingleNavLink
                                        key={docType.title}
                                        {...docType}
                                        onClick={(): void => {
                                            setTimeout(() => changeUserTourStep(userTourStepOpenDocumentUploading), 1000);
                                        }}
                                    />
                                );
                            })}
                        </List>
                    </React.Fragment>
                </Collapse>
            </React.Fragment>
        );
    };

const EnhancedDocumentMenuItem: React.FunctionComponent<DocumentsMenuItemProps> = compose(
    connect(null, {changeUserTourStep}),
)(DocumentsMenuItem);

export default EnhancedDocumentMenuItem;
